import React from 'react';
import Mapbox from '../components/Mapbox'
import Header from './Header'
import Splash from './Splash'
import About from './About'
import Footer from './Footer'
import mapboxgl from 'mapbox-gl'

import '../styles/mobile.scss'
import '../styles/container.scss'

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;

class Container extends React.Component {
    constructor(props){
        super(props);
        this.state={
            splash: true,
            about: false,
        }
        this.pageChange = this.pageChange.bind(this);
    }
    pageChange(e){
        var value = e.target.value;
        if (value === "remove-splash"){
            this.setState({
                splash: false,
                about: false
            });
        } else if (value === "add-splash"){
            this.setState({
                splash: true,
                about: false
            });
        } else if (value === "add-about"){
            this.setState({
                about: true,
                splash: false
                });
        }
    }
    
    //there is an event handler here 
    //this is sent down to Mapbox as a prop
    //when map moves, the event handler prop is triggered
    render(){
        return(
            <div className="container">
                <Header 
                    onClick={this.pageChange}
                />
                {this.state.splash && <Splash onClick={this.pageChange}/>} 
                {this.state.about && <About/>}
                <Mapbox/>
                <Footer />
            </div>
        )
    }

}

//Open on the page
//then click viewer
//when they get to search page, yes
//This project is for demonstration purposes only. 
//our github 

//mobile piece

export default Container;